import React, { useState } from 'react'
import styled from '@emotion/styled/macro'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const HOVER_TIMEOUT = 1000

const CopyContainer = styled('span')`
  margin: 0 5px;
  display: flex;

  &:hover {
    cursor: pointer;
  }
`

const Copied = styled('span')`
  font-size: 16px;
`

export default function Copy({ value, iconColour }) {
  const [copied, setCopied] = useState(false)

  return (
    <CopyContainer onClick={(e) => e.preventDefault()}>
      {copied ? (
        <Copied>Copied</Copied>
      ) : (
        <CopyToClipboard
          text={value}
          onCopy={() => {
            setCopied(true)
            setTimeout(() => setCopied(false), HOVER_TIMEOUT)
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 21L4 21C3.44772 21 3 20.5523 3 20L3 7C3 6.44772 3.44772 6 4 6L9.58579 6C9.851 6 10.1054 6.10536 10.2929 6.29289L13.7071 9.70711C13.8946 9.89464 14 10.149 14 10.4142V20C14 20.5523 13.5523 21 13 21Z" stroke="#2C2D3F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M10 6L10 4C10 3.44771 10.4477 3 11 3L16.5858 3C16.851 3 17.1054 3.10536 17.2929 3.29289L20.7071 6.70711C20.8946 6.89464 21 7.149 21 7.41421V17C21 17.5523 20.5523 18 20 18L14 18" stroke="#2C2D3F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14 11L10 11C9.44772 11 9 10.5523 9 10L9 6" stroke="#2C2D3F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21 8L17 8C16.4477 8 16 7.55228 16 7L16 3" stroke="#2C2D3F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </CopyToClipboard>
      )}
    </CopyContainer>
  )
}
